import { Component } from '@angular/core';

import { NotificationService } from './notification.service';
import { Notification } from './notification.model';

@Component({
  selector: 'wl-notification',
  styleUrls: ['notification.component.css'],
  templateUrl: 'notification.component.html',
    standalone: false
})
export class NotificationComponent {
  public _notifications: Notification[];
  public _notificationService: NotificationService;

  constructor(notificationService: NotificationService) {
    this._notificationService = notificationService;
    this._notifications = new Array<Notification>();

    this._notificationService.notificationAdded.subscribe(notification => {
      this._notifications.push(notification);

      if (notification.type.toLowerCase() == 'info' || notification.type.toLowerCase() == 'success') {
        //this will auto hide after 3 secs
        setTimeout(() => {
          this.hide.bind(this)(notification);
        }, 3000);
      }
    });
  }

  public hide(notification: Notification) {
    let index = this._notifications.indexOf(notification);

    if (index >= 0) {
      this._notifications.splice(index, 1);
    }
  }

  public hideById(id: number) {
    let index: number = -1;

    for (let notify of this._notifications) { // for acts as a foreach
      index += 1;
      if (notify.id == id) {
        break;
      }
    }

    if (index >= 0) {
      this._notifications.splice(index, 1);
    }
  }
}
